<!--
  * name: UtilMenus
  * description: 유틸 메뉴 컴포넌트
-->
<template>
  <div class="util-wrap">
    <b-container class="bv-example-row bv-example-row-flex-cols">
      <b-row class="util-row" align-v="center">
        <b-col class="col util-lang">
          <!-- 병헌 : PC 다국어 버튼 -->
          <ul class="util-lang-ul hide-mobile display-none">
            <li v-for="language in languages" :key="language.code">
              <a href="" :class="language.classes">{{ language.name }}</a>
            </li>
          </ul>
          <router-link to="/" class="mobile-logo hide-pc">RIMAN</router-link>
          <!-- 병헌 : 모바일 메인 로고 -->
        </b-col>
        <b-col class="col util-menu">
          <!-- 병헌 : PC 유틸메뉴 -->
          <account-menu
            @toggle-srch="$emit('toggle-srch')"
            :isPC="true"
            :isSrchOpen="isSrchOpen"
            :show-mobile-menu="showMobileMenu"
          />
          <button
            class="mobile-hamburger hide-pc"
            @click="toggleMobileMenu"
            type="button"
          >
            메뉴
          </button>
          <!-- 병헌 : 모바일 햄버거 버튼 -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AccountMenu from './AccountMenu.vue';

export default {
  name: 'UtilMenus',
  components: {
    AccountMenu,
  },
  props: {
    showMobileMenu: {
      // 모바일 메뉴 오픈 여부 Flag
      type: Boolean,
      required: true,
    },
    isSrchOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languages: [
        // 다국어 버튼 리스트
        { code: 'KO', name: '한', classes: [] },
        { code: 'EN', name: 'A', classes: ['btn-lang-eng'] },
        { code: 'CN', name: '文', classes: [] },
      ],
    };
  },
  methods: {
    // ## 모바일 메뉴 Show/Hide 처리 메소드
    toggleMobileMenu() {
      this.$emit('toggle-mobile-menu', !this.showMobileMenu);
    },
  },
};
</script>

<style></style>
